/**
 * Validates if a string is in valid ISO 8601 date format (YYYY-MM-DD)
 * @param dateString - The date string to validate
 * @returns true if the date string is valid, false otherwise
 */
export const isValidISODate = (dateString: string): boolean => {
    // Check format: YYYY-MM-DD
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) {
        return false;
    }

    // Check if it's a valid date
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return false;
    }

    // Verify the date components match the input
    // (prevents cases like "2024-02-30" being converted to "2024-03-02")
    const [year, month, day] = dateString.split('-').map(Number);
    return (
        date.getUTCFullYear() === year &&
        date.getUTCMonth() === month - 1 &&
        date.getUTCDate() === day
    );
};

/**
 * Validates if startDate is before or equal to endDate
 * @param startDate - The start date string (YYYY-MM-DD)
 * @param endDate - The end date string (YYYY-MM-DD)
 * @returns true if startDate <= endDate, false otherwise
 */
export const isValidDateRange = (startDate: string, endDate: string): boolean => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    return start <= end;
};
